import React from 'react';
import TemplateContacts from '../template/templateContacts';

function ContactsPage() {

    return (
        <div>
            <TemplateContacts />
        </div>
    );
}

export default ContactsPage;